import React from 'react'
import { PLAN_METADATA, getSeatRules } from '~/service/Billing/billingConstants'
import { useApp } from '~/context/appContext'
import PlanCounter from '~/molecules/Billing/PlanCounter'
import ChangePlanPlanList from '~/molecules/Billing/ChangePlanPlanList'
import ChangePlanPaymentList from '~/molecules/Billing/ChangePlanPaymentList'
import ChangePlanTerms from '~/molecules/Billing/ChangePlanTerms'

export default function ChangePlanFormPanel({
  subscription,
  unusedSeats,
  seats,
  onSeatsChange,
  isCounterDisabled,
  plans,
  selectedUnit,
  onPlanSelect,
  restrictUnit,
  paymentMethods,
  selectedPaymentId,
  onPaymentChange,
  onAddPayment,
  estimate,
  onViewDetails,
  termsClassName = 'hidden lg:block mt-7',
}) {
  const { company } = useApp()
  const { minCount: minSeatCount, step } = getSeatRules(company)
  const hasNoSubscriptionOrCanceled = !subscription || subscription.status === 'canceled'
  const hasHighLicenses = !hasNoSubscriptionOrCanceled && subscription && (subscription.licensesCount || 0) >= minSeatCount
  const minCount = hasHighLicenses ? 0 : minSeatCount
  const totalSeats = hasNoSubscriptionOrCanceled ? seats : (subscription.licensesCount || 0) + seats
  const counterLabel = PLAN_METADATA[selectedUnit]?.counterLabel

  return (
    <div className='flex-1 min-w-0 px-6 pt-4 lg:pb-4 overflow-y-auto'>
      <div className='space-y-7 max-lg:mb-6'>
        {/* Info bar */}
        {unusedSeats > 0 && (
          <p className='text-sm text-llama-grey-7 mb-6'>
            Your current <span className='font-bold text-base'>{subscription?.planLicense?.name}</span> plan has{' '}
            <span className='font-bold text-base'>{unusedSeats}</span> unused seats{' '}
            <span
              className='text-llama-purple-4 underline cursor-pointer'
              onClick={onViewDetails}
            >
              View details
            </span>
          </p>
        )}

        {/* Step 1: seat count */}
        <div className='mb-6'>
          <p className='text-sm font-semibold text-llama-grey-7 mb-1'>
            {counterLabel === 'courses' ? 'Select how many seats you would like to add:' : 'Select how many people you would like to add:'}
          </p>
          <p className='text-sm text-llama-grey-5 pb-2'>
            (Minimum of {minCount} seats, in increments of {step} seats)
          </p>
          <div className='w-fit min-w-[150px]'>
            <PlanCounter value={seats} onChange={onSeatsChange} disabled={isCounterDisabled} circleIcons autoSize minCount={minCount} step={step} />
          </div>
        </div>

        {/* Step 2: plan selection */}
        <ChangePlanPlanList
          plans={plans}
          selectedUnit={selectedUnit}
          onSelect={onPlanSelect}
          restrictUnit={restrictUnit}
          estimate={estimate}
        />

        {/* Step 3: payment method */}
        <ChangePlanPaymentList
          paymentMethods={paymentMethods}
          selectedPaymentId={selectedPaymentId}
          onChange={onPaymentChange}
          onAddPayment={onAddPayment}
        />
      </div>

      <div className={termsClassName}>
        <ChangePlanTerms estimate={estimate} totalSeats={totalSeats} cadence={subscription?.cadence} />
      </div>
    </div>
  )
}
